import { createContext } from "react";

export const SearchTermContext = createContext();
